var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRewardsTrophyGray = function SvgRewardsTrophyGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 0C41.136 0 53 11.864 53 26.5S41.136 53 26.5 53 0 41.136 0 26.5 11.864 0 26.5 0Z",
    fill: "#F2F4FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#RewardsTrophyGray_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.312 17.218H34.15a1.844 1.844 0 0 0-1.721-1.22H21.443a1.843 1.843 0 0 0-1.721 1.22H16.56a.61.61 0 0 0-.61.61v3.968a1.855 1.855 0 0 0 1.33 1.758l3.357.964a15.709 15.709 0 0 0 2.027 3.662 3.1 3.1 0 0 0 1.623 1.099l-.89 3.784h-1.075a1.806 1.806 0 0 0-1.733 1.22l-.94 2.82a.587.587 0 0 0 .293.736.634.634 0 0 0 .28.07H33.65a.634.634 0 0 0 .5-.257.587.587 0 0 0 .073-.55l-.94-2.794a1.806 1.806 0 0 0-1.733-1.221h-1.074l-.891-3.784a3.1 3.1 0 0 0 1.623-1.099 15.71 15.71 0 0 0 2.027-3.662l3.356-.964a1.856 1.856 0 0 0 1.33-1.758v-3.967a.612.612 0 0 0-.61-.635ZM17.61 22.383a.61.61 0 0 1-.44-.586v-3.357h2.442v.61c.004 1.374.193 2.742.562 4.065l-2.564-.732Zm14.514 12.34.683 2.027H21.065l.683-2.027a.61.61 0 0 1 .574-.415h9.228a.61.61 0 0 1 .574.415Zm-7.47-1.635.854-3.662h2.856l.855 3.662h-4.566Zm5.578-5.615a1.819 1.819 0 0 1-1.465.732h-3.662a1.82 1.82 0 0 1-1.465-.732 14.159 14.159 0 0 1-2.807-8.423v-1.22a.61.61 0 0 1 .61-.61H32.43a.61.61 0 0 1 .61.61v1.22a14.16 14.16 0 0 1-2.807 8.423Zm6.47-5.676a.61.61 0 0 1-.44.586l-2.564.732a15.33 15.33 0 0 0 .562-4.065v-.61H36.7v3.357Z",
    fill: "#5C7AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "RewardsTrophyGray_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(15.95 15.969)",
    d: "M0 0h21.972v21.972H0z"
  })))));
};

export default SvgRewardsTrophyGray;